/**
 * Миксин для работы с Verbox
 */
export default {
    methods: {
        // открытие окна Verbox
        onOpenVerbox() {
            if (typeof Verbox !== 'undefined') {
                Verbox("openSupport");
            }
        },
        // скрытие иконки Verbox
        onHideVerboxIcon() {
            if (typeof Verbox !== 'undefined') {
                Verbox("hideTrigger");
            }
        },
        // отображение иконки Verbox
        onShowVerboxIcon() {
            if (typeof Verbox !== 'undefined') {
                Verbox("showTrigger");
            }
        },
        // отправка сообщения в Verbox
        onSendVerboxMessage({text, openChat = true}) {
            if (typeof Verbox !== 'undefined') {
                Verbox('sendMessage', {
                    text: text,
                    callback: openChat ? this.onOpenVerbox : undefined,
                });
            }
        },
        // открытие Verbox для опроса обратной связи
        onOpenSupportFeedbackVerbox() {
            if (typeof Verbox !== 'undefined') {
                Verbox("startBot", {"schemeId":"zsumzvne18igbrd6e7oa5ch48yyar8ce", callback: this.onOpenVerbox});
            }
        },
    },
};
